export enum EmissionFactorCategory {
  Transport = 'transport',
  Accommodation = 'accommodation',
  Activity = 'activity',
  // Meal = 'meal', // not yet implemented
}

export interface CustomFactor {
  id: string;
  name: string;
  source?: string;
  description?: string;
  category: EmissionFactorCategory;
  valuePerKm?: number | null;
  valuePerH?: number | null;
  speed?: number | null;
  valuePerNight?: number | null;
  uncertainty?: number | null;
  validated?: boolean;
}

export interface AdminCustomFactor extends CustomFactor {
  company: { id: string; name: string };
}

export interface CustomFactorDto {
  name: string;
  source?: string;
  description?: string;
  category: EmissionFactorCategory;
  valuePerKm?: number | null;
  valuePerH?: number | null;
  speed?: number | null;
  valuePerNight?: number | null;
  uncertainty?: number | null;
}
